<template>
  <div v-if="isEditing">
    <el-form-item prop="title" label="题目">
      <wjQuillEditor :content="tempQuesData.title" :config="config" @onChange="handleEditorChange"></wjQuillEditor>
    </el-form-item>
    <el-form-item label="备注">
      <el-input class="editor-input" v-model="tempQuesData.description"></el-input>
    </el-form-item>
    <div class="clear-fix">
      <span
        v-if="tempQuesData.referFlag"
        class="addOtherBotton quoteOption bottom10 matrixPart"
      >此题选项来源于第 {{tempQuesData.referIndex}} 题中的选中项</span>
      <div v-else class="matrixPart">
        <p class="matrix-tips">问题设置（纵轴）</p>
        <el-form
          :rules="optRule"
          v-for="(title, index) in tempQuesData.subTitles"
          label-width="80px"
          :model="title"
          :key="index"
        >
          <el-form-item prop="text" :label="'问题' + (index + 1)">
            <el-input class="matrix-input" v-model="title.text" :id="'opt_' + title.id"></el-input>
            <i
              class="el-icon-close"
              @click="deleteOption(tempQuesData, tempQuesData.subTitles, index)"
            ></i>
          </el-form-item>
        </el-form>
        <div
          class="addOptionBtn addMatrixOptionBtn"
          @click="addSubTitles(tempQuesData.subTitles)"
        >新建问题</div>
        <el-button type="text" @click="handleTitleBatchChange">批量修改</el-button>
      </div>
      <div class="matrixPart">
        <p class="matrix-tips">选项设置（横轴）</p>
        <el-form
          :rules="optRule"
          v-for="(option, index) in tempQuesData.options"
          label-width="80px"
          :model="option"
          :key="index"
        >
          <el-form-item prop="text" :label="'选项' + (index + 1)">
            <el-input class="matrix-input" v-model="option.text" :id="'opt_' + option.id"></el-input>
            <i
              class="el-icon-close"
              @click="deleteOption(tempQuesData, tempQuesData.options, index)"
            ></i>
          </el-form-item>
        </el-form>
        <div class="addOptionBtn addMatrixOptionBtn" @click="addOptions(tempQuesData.options)">新建选项</div>
        <el-button type="text" @click="handleOptBatchChange">批量修改</el-button>
      </div>
    </div>
    <el-collapse v-model="advancedSetting" @change="handleSettingChange" class="backgroundGray">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="advanced-setting-title backgroundGray">
            <span class="more-setting-btn">
              {{advancedSettingTitle}}
              <i :class="advanceSettingIcon"></i>
            </span>
          </div>
        </template>
        <div class="backgroundGray">
          <div class="edit-settings">
            <el-checkbox v-model="tempQuesData.referFlag">问题引用</el-checkbox>
            <el-select
              v-show="tempQuesData.referFlag"
              v-model="tempQuesData.refer"
              @change="handleReferChange"
              size="mini"
              :class="{errorTooltip:(!tempQuesData.refer && tempQuesData.referFlag)}"
            >
              <el-option
                v-for="(checkbox, idx) in checkboxs"
                :label="(checkbox.realIndex + 1) + '.' + checkbox.title"
                :value="checkbox.id"
                :key="idx"
              ></el-option>
            </el-select>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
  <div v-else>
    <div class="ques-title">
      {{ ques.index + 1 }}.
      <p style="display: inline-block;" v-html="ques.title"></p>
      <i v-if="ques.required" class="required-icon">*</i>
    </div>
    <p class="ques-desc">{{ ques.description }}</p>
    <span v-if="ques.referFlag">此题子问题来源于第 {{ques.referIndex}} 题中的选中项</span>
    <div class="inputs">
      <div class="matrix-group table-scoll">
        <table class="table_freezed">
          <thead>
            <tr>
              <td></td>
              <th class="option_title" v-for="(opt, idx) in ques.options" :key="idx">
                <p>{{ opt.text }}</p>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(title, idx) in ques.subTitles" :key="idx">
              <th class="sub_title">
                <div class="subtitle_text">{{ title.text }}</div>
              </th>
              <td :colspan="ques.options.length">
                <el-checkbox-group v-model="title.checked" @change="handleMatrixCheckbox(ques)">
                  <el-checkbox
                    v-for="opt in ques.options"
                    :label="opt.id"
                    :key="opt.id"
                    class="option_choose"
                  ></el-checkbox>
                </el-checkbox-group>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <table class="matrix_group_mirror">
        <thead>
          <tr>
            <td style="height: 22px;"></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(title, idx) in ques.subTitles" :key="idx">
            <td class="sub_title">
              <div class="subtitle_text">{{ title.text }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import wjQuillEditor from "./wj-quill-editor.vue";
import { uuid } from '../utils/utils'
import { quesMixin } from '../utils/mixins'

export default {
  name: "matrix-checkbox",
  mixins: [quesMixin],
  data() {
    return {
    };
  },
  props: ["tempQuesData", "isEditing", "ques", "checkboxs", "survey", "config"],
  components: {
    wjQuillEditor
  },
  methods: {
    handleTitleBatchChange() {
      this.$emit("batchChange", this.tempQuesData.subTitles, "subTitles");
    },
    handleOptBatchChange() {
      this.$emit("batchChange", this.tempQuesData.options, "options");
    },
    addOptions(opt) {
      opt.push({
        id: uuid(),
        text: ""
      });
      this.$nextTick(() => {
        let _opt = document.getElementById("opt_" + opt[opt.length - 1].id);
        _opt && _opt.focus();
        _opt = null;
      });
    },
    addSubTitles(title) {
      title.push({
        id: uuid(),
        text: "",
        checked: []
      });
      this.$nextTick(() => {
        let _opt = document.getElementById("opt_" + title[title.length - 1].id);
        _opt && _opt.focus();
        _opt = null;
      });
    },
    deleteOption(ques, arr, idx) {
      if (arr[idx].id === "98") ques.blankSetting = [];
      arr.splice(idx, 1);
    },
    handleReferChange(refer) {
      let pages = this.survey.pages;
      this.tempQuesData.subTitles = [];
      for (let i = 0; i < pages.length; i++) {
        pages[i].questions.forEach(item => {
          let { id, index, title, type, options } = item;
          if (type === "checkbox" && id === refer) {
            options.forEach(val => {
              this.tempQuesData.subTitles.push({
                id: val.id,
                text: val.text,
                checked: []
              });
            });
            this.tempQuesData.referIndex = index + 1;
          }
        });
      }
    },
    handleEditorChange(data) {
      this.tempQuesData.title = data;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/matrix-checkbox.vue